module.exports = __webpack_public_path__ + "static/media/Dot.07f038bb.svg";